import { useEffect, useState } from 'react';

import { MediaType } from '@/types';

export const useDeviceDetection = (): MediaType => {
  const [dimension, setDimension] = useState<MediaType>(MediaType.Desktop);
  const deviceDetection = () => {
    if (window.innerWidth <= 767) {
      setDimension(MediaType.Mobile);

      return;
    }

    if (window.innerWidth > 767 && window.innerWidth < 1154) {
      setDimension(MediaType.Tablet);

      return;
    }

    setDimension(MediaType.Desktop);
  };

  useEffect(() => {
    deviceDetection();
    window.addEventListener('resize', deviceDetection);

    return () => {
      window.removeEventListener('resize', deviceDetection);
    };
  });

  return dimension;
};
